import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      services: [],
      reference: null
    }
  },
  getters: {
    services (state) {
      return state.services
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.services = []
    },
    add (state, payload) {
      state.services.push(payload)
    },
    update (state, payload) {
      const index = state.services.findIndex(service => service.key === payload.key)
      if (index !== -1) {
        Vue.set(state.services, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.services.findIndex(service => service.key === payload.key)
      if (index !== -1) {
        state.services.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('services')
        var reference = dbRef.orderBy('createdAt', 'asc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              owner: change.doc.data().owner,
              entryCode: change.doc.data().entryCode,
              groups: change.doc.data().groups,
              users: change.doc.data().users,
              name: change.doc.data().name,
              subTitle: change.doc.data().subTitle,
              tosLink: change.doc.data().tosLink,
              ppLink: change.doc.data().ppLink,
              icon: change.doc.data().icon,
              company: change.doc.data().company,
              position: change.doc.data().position,
              representative: change.doc.data().representative,
              routine: change.doc.data().routine,
              chats_ref: change.doc.data().chats_ref,
              enable: change.doc.data().enable,
              option: change.doc.data().option,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            if (change.type === 'added') {
              commit('add', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'modified') {
              commit('update', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'removed') {
              commit('remove', JSON.parse(JSON.stringify(payload)))
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['service/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Service.js